import React from 'react'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import Layout from 'src/components/layouts'
import PartnerWithTheLeader from 'src/components/pages/PartnerWithTheLeader'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'
import { getMegamenuData } from 'src/common/back/megamenu'

export async function getServerSideProps(context) {
  const jsonLdSchemas = await getContentfulJsonLd(
    'partner-with-the-leader-in-debt-resolution/'
  )
  let megamenuData = null
  try {
    megamenuData = await getMegamenuData(context)
  } catch (error) {}

  return {
    props: {
      jsonLdSchemas,
      megamenuData: megamenuData || null,
    },
  }
}

const PartnerWithTheLeaderPage = ({ megamenuData, jsonLdSchemas = null }) => (
  <>
    <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
    <Layout footerClassName="max-w-1400" megamenuData={megamenuData}>
      <PartnerWithTheLeader />
    </Layout>
  </>
)

export default PartnerWithTheLeaderPage
